import {
  AsesorChargeApi,
  AsesorsApi,
  ContactApi,
  ContactComunicationApi,
  ContactPersonalDataApi,
  ContactSocialDataApi,
} from "../../../Shared/Constants/api";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";

export const showContactApi = async (id) => {
  try {
    let response = await axiosInstance.get(`${ContactApi}/${id}`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const showContactPersonalDataApi = async (id) => {
  try {
    let response = await axiosInstance.get(`${ContactPersonalDataApi}/${id}`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const showContactSocialDataApi = async (id) => {
  try {
    let response = await axiosInstance.get(`${ContactSocialDataApi}/${id}`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
export const showContactComunicationDataApi = async (id) => {
  try {
    let response = await axiosInstance.get(`${ContactComunicationApi}/${id}`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const showContactEntitiesApi = async (id) => {
  try {
    let response = await axiosInstance.get(`${ContactApi}/${id}/entities`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const showContactAsesorsApi = async (id) => {
  try {
    let response = await axiosInstance.get(`${ContactApi}/${id}/asesors`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};

export const showAsesorContactsApi = async (id) => {
  try {
    let response = await axiosInstance.get(`${AsesorsApi}/${id}/contacts`);

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
